import {
  ClientSelectionState,
  IClientSelectionState
} from '../ClientSelectionState/ClientSelection.state';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserEmployerModel } from '../../models/person';
import { CompaniesService } from '../../services/companies.service';
import { ClientFeatureWhitelistService } from '../../services/client-feature-whitelist.service';
import { ChangeRequestService } from '../../services/change-request.service';
import { ClientTimeOffRequestService } from '../../services/time-off-request.service';

export class SetPersonId {
  static readonly type = '[EmployerSelection] Set Person Id';
  constructor(public personId: number) {}
}

export class SetSelectedEmployer {
  static readonly type = '[EmployerSelection] Set Selected Employer';
  constructor(public employer: UserEmployerModel) {}
}

export interface IEmployerSelectionState extends IClientSelectionState {
  personId: number;
  selectedEmployer: UserEmployerModel;
}
@State<IEmployerSelectionState>({
  name: 'clientSelection',
  defaults: {
    client: null,
    clientSetup: null,
    clientCode: null,
    availableClients: [],
    locations: [],
    canEnableChangeRequests: false,
    openChangeRequests: [],
    personId: null,
    selectedEmployer: null,
    canEnableTimeOff: false
  }
})
@Injectable()
export class EmployerSelectionState extends ClientSelectionState {
  constructor(
    companiesService: CompaniesService,
    whitelistService: ClientFeatureWhitelistService,
    changeRequestService: ChangeRequestService,
    clientTimeOffService: ClientTimeOffRequestService
  ) {
    super(companiesService, whitelistService, changeRequestService, clientTimeOffService);
  }

  @Action(SetPersonId)
  setPersonId(ctx: StateContext<IEmployerSelectionState>, action: SetPersonId) {
    ctx.patchState({ personId: action.personId });
  }

  @Action(SetSelectedEmployer)
  setSelectedEmployer(ctx: StateContext<IEmployerSelectionState>, action: SetSelectedEmployer) {
    ctx.patchState({ selectedEmployer: action.employer });
  }

  @Selector()
  static personId(state: IEmployerSelectionState) {
    return state.personId;
  }

  @Selector()
  static selectedEmployer(state: IEmployerSelectionState) {
    return state.selectedEmployer;
  }
}
